/**
 * RL-1303: copy or save the MFA recovery codes, only on an explicit click.
 * The codes stay in memory: never logged, never put in web storage, a URL or
 * an analytics event. The download is an in-memory Blob whose object URL is
 * revoked straight after the click.
 */
export const RECOVERY_CODES_FILENAME = 'ommri-care-admin-recovery-codes.txt';

export function recoveryCodesText(codes: string[]): string {
  return [
    'Ommri Care Admin: two-factor recovery codes',
    'Each code signs you in once if you lose your phone. Keep this file somewhere safe.',
    '',
    ...codes,
    '',
  ].join('\n');
}

export function downloadRecoveryCodes(
  codes: string[],
  doc: Document = document,
) {
  const blob = new Blob([recoveryCodesText(codes)], {
    type: 'text/plain;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const a = doc.createElement('a');
  a.href = url;
  a.download = RECOVERY_CODES_FILENAME;
  a.rel = 'noopener';
  a.style.display = 'none';
  doc.body.appendChild(a);
  try {
    a.click();
  } finally {
    a.remove();
    // Next tick, so every browser has started the download first.
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
}

/** Copies the codes; false when the clipboard is not available or refused. */
export async function copyRecoveryCodes(codes: string[]): Promise<boolean> {
  try {
    if (!navigator.clipboard?.writeText) return false;
    await navigator.clipboard.writeText(codes.join('\n'));
    return true;
  } catch {
    return false;
  }
}
